// extracted by mini-css-extract-plugin
module.exports = {"layout-content":"layout_layout-content___o3j2"};